import { sideEffect } from './sideEffect'

export * from './annotations'
export * from './batchObserve'
export * from './closest'
export * from './define'
export * from './dispatch'
export * from './errors'
export * from './event'
export * from './internals'
export * from './observe'
export * from './operations'
export * from './patch'
export * from './reactions'
export * from './reactive'
export * from './tojs'
export * from './types'
export * from './version'

sideEffect()
